/**
 * Run before React renders. Cache-bust leftover was deleted after 31661.
 */
export async function ensureFreshBundleBeforeRender(): Promise<void> {
  return;
}
